import api from "src/api/axiosInstance";

export const deletelineitemApi = async (id) => {
  try {
    await api.delete(`/lineitem/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const addLineItemToOrderApi = async (
  orderId,
  productId,
  quantity,
  variantId,
  slotId,
) => {
  let payload = JSON.stringify({
    order_id: orderId, // Pass orderId in both URL and body
    productId: productId,
    quantity: quantity,
  });
  if (variantId) {
    payload = JSON.stringify({
      order_id: orderId,
      productId: productId,
      variantId: variantId,
      quantity: quantity,
    });
  }
  if (slotId) {
    payload = JSON.stringify({
      order_id: orderId,
      productId: productId,
      slotId: slotId,
      quantity: quantity,
    });
  }

  try {
    const response = await api.post(
      `orders/${orderId}/lineitem`,
      payload // Sending category in the request body
    );
    
    // Check if the response indicates an error (status: 1 means error)
    if (response.data && response.data.status === 1) {
      return {
        success: false,
        data: response.data.details?.lineitem || null,
        error: {
          message: response.data.message || 'Unknown error occurred',
          status: response.data.status
        }
      };
    }
    
    // Return the response data for success cases
    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error) {
    console.log('LineItem API Error:', error);
    
    // Handle the new error response format
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      return {
        success: false,
        data: errorData.details?.lineitem || null,
        error: {
          message: errorData.message || 'Unknown error occurred',
          status: errorData.status || 1
        }
      };
    }
    
    // Fallback for other types of errors
    return {
      success: false,
      data: null,
      error: {
        message: error.message || 'Network error occurred',
        status: 0
      }
    };
  }
};
